@if (!ready()) {
  <div class="event-tooltip">
    <div class="event-tooltip__body event-tooltip__body--loading">
      <sim-spinner [diameter]="24" [strokeWidth]="3" />
    </div>
  </div>
} @else {
  @if (event(); as event) {
    <div class="event-tooltip">
      <div class="event-tooltip__header">{{ event.name }}</div>
      <div class="event-tooltip__body">
        @if (description()) {
          <p class="event-tooltip__description">{{ description() }}</p>
        }

        <div class="event-tooltip__when">
          <div class="event-tooltip__date">
            <sim-icon icon="calendar" [sizeInPx]="20" color="var(--text-icon)" />
            <span class="event-tooltip__date-text">
              {{ startDate() ? (startDate() | date: 'dd/MM/yyyy') : '-' }}
              @if (endDate(); as endDate) {
                <span class="event-tooltip__date-separator">-</span>
                <sim-icon icon="calendar" [sizeInPx]="20" color="var(--text-icon)" />
                {{ endDate | date: 'dd/MM/yyyy' }}
              }
            </span>
          </div>
          @if (timeRange()) {
            <div class="event-tooltip__time">
              <sim-icon icon="clock" [sizeInPx]="16" color="var(--text-icon-lighter)" />
              <span class="event-tooltip__time-text">{{ timeRange() }}</span>
            </div>
          }
          <sim-recurrence-badge
            class="event-tooltip__recurrence"
            [label]="recurrenceLabel()"
            [recurring]="isRecurring()"
          />
        </div>

        <sim-event-avatar-stack
          class="event-tooltip__assignees"
          [assignees]="assignees()"
          [size]="30"
          trigger="hover"
        />

        @if (canShowMore) {
          <div class="event-tooltip__footer">
            <button
              type="button"
              class="event-tooltip__show-more"
              (click)="showMore()"
              i18n="@@EVENT_TOOLTIP_SHOW_MORE"
            >
              Show more
            </button>
          </div>
        }
      </div>
    </div>
  }
}
